import { render, staticRenderFns } from "./add-cate-dialog.vue?vue&type=template&id=70821750&"
import script from "./add-cate-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-cate-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-cate-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports